import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productBundleComponentsTitle: {
    description: 'products details, bundles tab header',
    defaultMessage: 'Bundle Components',
    id: 'eY2R6n',
  },
  productBundleComponentSku: {
    description: 'products details, bundles tab, component sku header',
    defaultMessage: 'SKU',
    id: '04dO0Q',
  },
  showBundleOnPackingSlip: {
    description: 'products details, bundles tab, show bundle on packing slip label.',
    defaultMessage: 'Show bundle on packing slip',
    id: '4dtjZt',
  },
  bundlePackingSlipDisplayModeLabel: {
    description: 'products details, bundles tab, label above the dropdown that controls how bundle items appear on packing slips',
    defaultMessage: 'Bundle on packing slip',
    id: '3g2fkr',
  },
  displayModeChildrenOnly: {
    description: 'products details, bundles tab, dropdown option to show only the bundle child components on the packing slip',
    defaultMessage: 'Show components only',
    id: 'wBcTvV',
  },
  displayModeParentOnly: {
    description: 'products details, bundles tab, dropdown option to show only the bundle parent product on the packing slip',
    defaultMessage: 'Show bundle only',
    id: 'l/AiIy',
  },
  displayModeBoth: {
    description: 'products details, bundles tab, dropdown option to show both bundle parent and components on the packing slip',
    defaultMessage: 'Show bundle and components',
    id: 'VYwYew',
  },
  productBundleComponentName: {
    description: 'products details, bundles tab, component name header',
    defaultMessage: 'Name',
    id: 'ESkKsE',
  },
  productBundleComponentQuantity: {
    description: 'products details, bundles tab, component quantity header',
    defaultMessage: 'Quantity',
    id: 'Pv+S9N',
  },
  productBundleComponentRemove: {
    description: 'products details, bundles tab, component remove header',
    defaultMessage: 'Remove',
    id: 'pByHph',
  },
  productBundleComponentAdd: {
    description: 'products details, bundles tab, add component button',
    defaultMessage: '{icon} <span>Add Component</span>',
    id: 'APHCxw',
  },
  bundleForSku: {
    description: 'products details, bundles tab, label for individual bundle',
    defaultMessage: 'Bundle for {sku}',
    id: 'fVIYpe',
  },
});
